export default "__VITE_ASSET__MpoYRnz8__"